import { render } from "./Table5.vue?vue&type=template&id=710a61f1"
import script from "./Table5.vue?vue&type=script&lang=js"
export * from "./Table5.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__